import { Endpoint } from '../endpoint';

export const ReferenceValueLink = new Endpoint('reference_value_link');
